import axios from 'axios';
import store from '../store';
import { atividadeService } from '../../domain/atividade/AtividadeService';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error.response);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const getDefaultState = () => {
  return {
    atividades: [],
    atividadesSelected: [],
    ocorrencias: [],
    checklists: [],
    atividadeTags: [],
    atividadeColaboradores: [],
    allAtividadeClientes: [],
    atividadeClientes: [],
    atividadeProjetos: []
  }
}

const state = getDefaultState();

// const state = {
//   atividades: [],
//   atividadesSelected: [],
//   ocorrencias: [],
//   checklists: [],
//   atividadeTags: [],
//   atividadeColaboradores: [],
//   allAtividadeClientes: [],
//   atividadeClientes: [],
//   atividadeProjetos: []
// };

const getters = {
  // Atividade
  atividades: state => state.atividades,
  atividadesSelected: state => state.atividadesSelected,
  getAtividade: state => id => state.atividades.find(atividade => atividade.IdAtividade === id),
  countAtividades: state => state.atividades.length,
  // Ocorrência
  ocorrencias: state => state.ocorrencias,
  getOcorrencia: state => id => state.ocorrencias.find(ocorrencia => ocorrencia.IdOcorrencia === id),
  countOcorrencias: state => state.ocorrencias.length,
  // tag
  atividadeTags: state => state.atividadeTags,
  getAtividadeTag: state => id => state.atividadeTags.find(tag => tag.IdTag === id),
  countAtividadeTags: state => state.atividadeTags.length,
  // colaborador !!REFATORAR PARA COLABORADOR
  atividadeColaboradores: state => state.atividadeColaboradores,
  getColaborador: state => id => state.atividadeColaboradores.find(colaborador => colaborador.IdColaborador === id),
  countColaboradores: state => state.atividadeColaboradores.length,
  // checklist
  checklists: state => state.checklists,
  getChecklist: state => id => state.checklists.find(checklist => checklist.IdCheckList === id),
  countChecklists: state => state.checklists.length,
  // cliente
  allAtividadeClientes: state => state.allAtividadeClientes,
  atividadeClientes: state => state.atividadeClientes,
  getCliente: state => id => state.atividadeClientes.find(cliente => cliente.IdCliente === id),
  countCliente: state => state.atividadeClientes.length,
  helpdeskCliente: state => state.helpdeskCliente,
  // projeto
  atividadeProjetos: state => state.atividadeProjetos,
};

const actions = {
  // Atividade
  resetAtividadeState ({ commit }) {
    commit('resetAtividadeState');
  },
  async fetchAtividades({ commit }, args) {
    let response = null;
    if (args.colaboradores.length) {
      response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?status=${args.status.join()}&idresponsavel=${args.usuario},${args.colaboradores.join()}`);
    } else {
      response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?status=${args.status.join()}`);
    }

    if (response.data.Atividades) {
      commit('setAtividades', response.data.Atividades);
    } else {
      commit('setAtividades', []);
    }
  },
  async fetchAtividadesNode({ commit }, args) {
    const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&todas=true`);

    if (response.data.length) {
      commit('setAtividades', response.data);
    } else {
      commit('setAtividades', []);
    }
  },
  async fetchMinhasAtividades({ commit }, args) {
    let response1 = null;
    let response2 = null;
    if (args.colaboradores.length) {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario},${args.colaboradores.join()}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&status=${args.status.join()}`);
    } else {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&status=${args.status.join()}`);
    }

    let atividades1 = response1.data.Atividades;
    let atividades2 = response2.data.Atividades;
    let minhasAtividades = atividades1 || [];

    if (atividades2) minhasAtividades = minhasAtividades.concat(atividades2);

    minhasAtividades ? commit('setAtividades', minhasAtividades) : commit('setAtividades', []);
  },
  async fetchMinhasAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?idResponsavel=${args.usuario.IdColaborador}&status=${args.status[0]}`);
      if (response.data.length) {
        commit('setAtividades', response.data);
      }
    } catch (error) {
      commit('setAtividades', []);
    }
  },
  async fetchMinhasAtividadesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?idLayoutSql=${args.idLayoutSql}&idResponsavel=${args.usuario.IdColaborador}`);
      if (response.data.length) {
        commit('setAtividades', response.data);
      } else {
        commit('setAtividades', []);
      }
    } catch (error) {
      commit('setAtividades', []);
    }
  },
  async fetchAtividadesParaVinculoNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&vincular=true&idProjeto=${args.idProjeto}&idTipoProjeto=${args.idTipoProjeto}`);
      commit('setAtividades', response.data);
    } catch (error) {
      commit('setAtividades', []);
    }
  },
  async fetchMesAtividades({ commit }, args) {
    let response1 = null;
    let response2 = null;
    if (args.colaboradores.length) {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario},${args.colaboradores.join()}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    } else {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    }

    let atividades1 = response1.data.Atividades;
    let atividades2 = response2.data.Atividades;
    let mesAtividades = atividades1 || [];

    if (atividades2) mesAtividades = mesAtividades.concat(atividades2);

    mesAtividades ? commit('setAtividades', mesAtividades) : commit('setAtividades', []);
  },
  async fetchMesAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setAtividades', response.data)
      }
    } catch (error) {
      commit('setAtividades', [])
    }
  },
  async fetchSemanaAtividades({ commit }, args) {
    let response1 = null;
    let response2 = null;
    if (args.colaboradores.length) {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario},${args.colaboradores.join()}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    } else {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    }

    let atividades1 = response1.data.Atividades;
    let atividades2 = response2.data.Atividades;
    let semanaAtividades = atividades1 || [];

    if (atividades2) semanaAtividades = semanaAtividades.concat(atividades2);

    semanaAtividades ? commit('setAtividades', semanaAtividades) : commit('setAtividades', []);
  },
  async fetchSemanaAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setAtividades', response.data)
      }
    } catch (error) {
      commit('setAtividades', [])
    }
  },
  async fetchOntemAtividades({ commit }, args) {
    let response1 = null;
    let response2 = null;
    if (args.colaboradores.length) {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario},${args.colaboradores.join()}&previsaomenorigual=${args.dataFinal}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&status=${args.status.join()}`);
    } else {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario}&previsaomenorigual=${args.dataFinal}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&status=${args.status.join()}`);
    }

    let atividades1 = response1.data.Atividades;
    let atividades2 = response2.data.Atividades;
    let ontemAtividades = atividades1 || [];

    if (atividades2) ontemAtividades = ontemAtividades.concat(atividades2);

    ontemAtividades ? commit('setAtividades', ontemAtividades) : commit('setAtividades', []);
  },
  async fetchOntemAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setAtividades', response.data)
      }
    } catch (error) {
      commit('setAtividades', [])
    }
  },
  async fetchPeriodoAtividades({ commit }, args) {
    let response1 = null;
    let response2 = null;
    if (args.colaboradores.length) {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario},${args.colaboradores.join()}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    } else {
      response1 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idresponsavel=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
      response2 = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&previsaomenorigual=${args.dataFinal}&previsaomaiorigual=${args.dataInicial}&status=${args.status.join()}`);
    }

    let atividades1 = response1.data.Atividades;
    let atividades2 = response2.data.Atividades;
    let periodoAtividades = atividades1 || [];

    if (atividades2) periodoAtividades = periodoAtividades.concat(atividades2);

    periodoAtividades ? commit('setAtividades', periodoAtividades) : commit('setAtividades', []);
  },
  async fetchPeriodoAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setAtividades', response.data)
      }
    } catch (error) {
      commit('setAtividades', [])
    }
  },
  async fetchPeriodoAtividadesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?idLayoutSql=${args.idLayoutSql}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setAtividades', response.data);
      } else {
        commit('setAtividades', []);
      }
    } catch (error) {
      commit('setAtividades', []);
    }
  },
  async fetchInteressadoAtividades({ commit }, args) {
    let response = null;
    if (args.colaboradores.length) {
      response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario},${args.colaboradores.join()}&status=${args.status.join()}`);
    } else {
      response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idinteressado=${args.usuario}&status=${args.status.join()}`);
    }

    response.data.Atividades ? commit('setAtividades', response.data.Atividades) : commit('setAtividades', []);
  },
  async fetchInteressadoAtividadesNode({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/atividades?status=${args.status[0]}&interessado=true&idResponsavel=${args.usuario.IdColaborador}`); 
      if (response.data.length) {
        commit('setAtividades', response.data);
      }
    } catch (error) {
      commit('setAtividades', []);
    }
  },
  async addAtividade({ commit }, atividade) {
    const response = await axios.post('http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade', atividade, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    atividade.IdAtividade = response.data.IdAtividade;
    commit('newAtividade', atividade);
    return response.data.IdAtividade;
  },
  async addAtividadeNode({ commit }, atividade) {
    const response = await axios.post(`${baseUrl}/atividades`, atividade, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    atividade.IdAtividade = response.data.IdAtividade;
    commit('newAtividade', atividade);
    return response.data.IdAtividade;
  },
  async deleteAtividadeNode({ commit }, id) {
    try {
      // const response = await axios.delete(`${baseUrl}/atividades/${id}`);
      const response = await atividadeService.deletaAtividade(id);
      commit('removeAtividade', id);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async updateAtividadeNode({ commit }, updAtividade) {
    try {
      // const response = await axios.put(`${baseUrl}/atividades/${updAtividade.IdAtividade}`, updAtividade);
      const response = await atividadeService.atualizaAtividade(updAtividade);
      if (response.data.notificacoesLidas) {
        const notificacoesLidas = response.data.notificacoesLidas;
        notificacoesLidas.forEach(notificacao => commit('marcaLida', notificacao));
      }
      commit('updateAtividade', updAtividade);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async finalizarAtividadeNode({ commit }, finAtividade) {
    // await axios.put(`${baseUrl}/atividades/${finAtividade.IdAtividade}`, finAtividade);
    try {
      const response = await atividadeService.finalizaAtividade(finAtividade);
      finAtividade.Status = 'F';
      commit('finalizaAtividade', finAtividade);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async voltarStatusAtividade({ commit }, idAtividade) {
    try {
      const response = await atividadeService.voltaStatusAtividade(idAtividade);
      commit('updateAtividade', response.data);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async selectAtividades({ commit }, atividades) {
    commit('newAtividadeSelected', atividades);
  },
  async resetAtividadesSelected({ commit }) {
    commit('resetAtividadesSelected');
  },
  async duplicaAtividade({}, obj) {
    await axios.post(`${baseUrl}/duplicaatividade`, obj, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
  },
  // Atividades Cliente
  async fetchAtividadesCliente({ commit }, id) {
    let response = null;
    response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/sql/21?IDCLIENTE=${id}`);

    if (response.data.Sql) {
      commit('setAtividades', response.data.Sql);
    } else {
      commit('setAtividades', []);
    }
  },
  async fetchAtividadesClienteNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividades?idCliente=${id}`);

    if (response.data.length) {
      commit('setAtividades', response.data);
    } else {
      commit('setAtividades', []);
    }
  },
  async fetchAtividadeById({ commit }, id) {
    let response = null;
    response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividade?idatividade=${id}`);

    if (response.data.Atividades) {
      commit('setAtividades', response.data.Atividades);
      return response.data.Atividades[0];
    } else {
      commit('setAtividades', []);
    }
  },
  async fetchAtividadeByIdNode({ commit }, id) {    
    try {
      const response = await axios.get(`${baseUrl}/atividades/${id}?idResponsavel=${JSON.parse(localStorage.getItem('user')).IdColaborador}`);
      commit('setAtividades', response.data);
      return response.data[0];
    } catch (error) {
      commit('setAtividades', []);
      return error;
    }
  },
  // Ocorrência
  async fetchOcorrencias({ commit }, id) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadeocorrencia?idEmpresa=1&idAtividade=${id}&status=A`);
    if (response.data.Ocorrencias) {
      commit('setOcorrencias', response.data.Ocorrencias);
    } else {
      commit('setOcorrencias', []);
    }
  },
  async fetchOcorrenciasNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadesocorrencias/1/${id}`);
    if (response.data.length) {
      commit('setOcorrencias', response.data);
    } else {
      commit('setOcorrencias', []);
    }
  },
  async fetchOcorrenciasSql({ commit }, args) {
    const response = await axios.get(`${baseUrl}/atividadesocorrencias?idLayoutSql=${args.idLayoutSql}`);
    if (response.data.length) {
      commit('setOcorrencias', response.data);
    } else {
      commit('setOcorrencias', []);
    }
  },
  async fetchOcorrenciasPeriodoSql({ commit }, args) {
    const response = await axios.get(`${baseUrl}/atividadesocorrencias?idLayoutSql=${args.idLayoutSql}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
    if (response.data.length) {
      commit('setOcorrencias', response.data);
    } else {
      commit('setOcorrencias', []);
    }
  },
  async addOcorrencia({ commit }, ocorrencia) {
    try {
      const response = await axios.post('http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadeocorrencia', ocorrencia, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      });
      // Atribui o IdOcorrencia cadastrado no banco
      ocorrencia.IdOcorrencia = parseInt(response.data.IdOcorrencia);
      commit('newOcorrencia', ocorrencia);      
      return ocorrencia;
    } catch (error) {
      return error.message;
    }
  },
  async addOcorrenciaNode({ commit }, ocorrencia) {
    try {
      const response = await axios.post(`${baseUrl}/atividadesocorrencias`, ocorrencia);
      if (response) {
        ocorrencia.IdOcorrencia = parseInt(response.data.IdOcorrencia);
        commit('newOcorrencia', ocorrencia);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },
  async updateOcorrencia({ commit }, updOCorrencia) {
    try {
      await axios.put(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadeocorrencia`, updOCorrencia, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      });
      commit('updateOcorrencia', updOCorrencia);
      return updOCorrencia;
    } catch (error) {
      return error.message;
    }
  },
  async updateOcorrenciaNode({ commit }, updOCorrencia) {
    try {
      const response = await axios.put(`${baseUrl}/atividadesocorrencias`, updOCorrencia);
      if (response) {
        commit('updateOcorrencia', updOCorrencia);
      }
      return response;
    } catch (error) {
      return error.message;
    }
  },
  async deleteOcorrencia({ commit }, ocorrencia) {
    await axios.delete(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadeocorrencia/1/${ocorrencia.IdAtividade}/${ocorrencia.IdOcorrencia}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeOcorrencia', ocorrencia.IdOcorrencia);
  },
  async deleteOcorrenciaNode({ commit }, ocorrencia) {
    await axios.delete(`${baseUrl}/atividadesocorrencias/1/${ocorrencia.IdAtividade}/${ocorrencia.IdOcorrencia}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeOcorrencia', ocorrencia.IdOcorrencia);
  },
  // Tag
  async fetchAtividadeTags({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadestags/1/${id}`);
    if (response.data.length) {
      commit('setAtividadeTags', response.data);
    } else {
      commit('setAtividadeTags', []);
    }
  },
  async addAtividadeTag({ commit }, tag) {
    try {
      // const response = await axios.post(`${baseUrl}/atividadestags`, tag);
      const response = await atividadeService.addAtividadeTag(tag);
      commit('newAtividadeTag', tag);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error;
    }
  },
  async deleteAtividadeTag({ commit }, tag) {
    await axios.delete(`${baseUrl}/atividadestags/1/${tag.IdAtividade}/${tag.IdTag}`);
    commit('removeAtividadeTag', tag.IdTag);
  },
  // Colaborador
  async fetchAtividadeColaboradores({ commit }, id) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecolaborador/1/${id}`);
    if (response.data.Colaboradores) {
      commit('setAtividadeColaboradores', response.data.Colaboradores);
    } else {
      commit('setAtividadeColaboradores', []);
    }
  },
  async fetchAtividadeColaboradoresNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadescolaboradores/1/${id}`);
    if (response.data.length) {
      commit('setAtividadeColaboradores', response.data);
    } else {
      commit('setAtividadeColaboradores', []);
    }
  },
  async addAtividadeColaborador({ commit }, colaborador) {
    await axios.post('http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecolaborador', colaborador, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('newAtividadeColaborador', colaborador);
  },
  async addAtividadeColaboradorNode({ commit }, colaborador) {
    try {
      // const response = await axios.post(`${baseUrl}/atividadescolaboradores`, colaborador);
      const response = await atividadeService.addAtividadeColaborador(colaborador);
      commit('newAtividadeColaborador', colaborador);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async deleteAtividadeColaborador({ commit }, colaborador) {
    await axios.delete(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecolaborador/1/${colaborador.IdAtividade}/${colaborador.IdColaborador}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeAtividadeColaborador', colaborador.IdColaborador);
  },
  async deleteAtividadeColaboradorNode({ commit }, colaborador) {
    await axios.delete(`${baseUrl}/atividadescolaboradores/1/${colaborador.IdAtividade}/${colaborador.IdColaborador}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeAtividadeColaborador', colaborador.IdColaborador);
  },
  // Checklist
  async fetchChecklists({ commit }, id) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadechecklist/1/${id}`);
    if (response.data.CheckLists) {
      commit('setChecklists', response.data.CheckLists);
    } else {
      commit('setChecklists', []);
    }
  },
  async fetchChecklistsNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadeschecklists/1/${id}`);
    if (response.data.length) {
      commit('setChecklists', response.data);
    } else {
      commit('setChecklists', []);
    }
  },
  async addChecklist({ commit }, checklist) {
    const response = await axios.post('http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadechecklist', checklist, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    // Atribui o IdCheckList cadastrado no banco
    checklist.IdCheckList = response.data.IdCheckList;
    // Adiciona o campo CKConcluido removido anteriormente ao enviar o POST
    checklist.CKConcluido = checklist.Concluido;
    // Remove o campo Concluido adicionado ao enviar o POST
    delete checklist.Concluido;
    commit('newChecklist', checklist);
  },
  async addChecklistNode({ commit }, checklist) {
    const response = await axios.post(`${baseUrl}/atividadeschecklists`, checklist);
    // Atribui o IdCheckList cadastrado no banco
    checklist.IdChecklist = response.data.IdChecklist;
    // Adiciona o campo CKConcluido removido anteriormente ao enviar o POST
    // checklist.CKConcluido = checklist.Concluido;
    // Remove o campo Concluido adicionado ao enviar o POST
    // delete checklist.Concluido;
    commit('newChecklist', checklist);
  },
  async updateChecklist({ commit }, updChecklist) {
    await axios.put(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadechecklist`, updChecklist, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    // Adiciona o campo CKConcluido removido anteriormente ao enviar o PUT
    // updChecklist.CKConcluido = updChecklist.Concluido;
    // Remove o campo Concluido adicionado ao enviar o PUT
    // delete updChecklist.Concluido;
    commit('updateChecklist', updChecklist);
  },
  async updateChecklistNode({ commit }, updChecklist) {
    await axios.put(`${baseUrl}/atividadeschecklists`, updChecklist);
    // Adiciona o campo CKConcluido removido anteriormente ao enviar o PUT
    // updChecklist.Concluido = updChecklist.Concluido;
    // Remove o campo Concluido adicionado ao enviar o PUT
    // delete updChecklist.Concluido;
    commit('updateChecklist', updChecklist);
  },
  async deleteChecklist({ commit }, checklist) {
    await axios.delete(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadechecklist/1/${checklist.IdAtividade}/${checklist.IdCheckList}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeChecklist', checklist.IdCheckList);
  },
  async deleteChecklistNode({ commit }, checklist) {
    await axios.delete(`${baseUrl}/atividadeschecklists/1/${checklist.IdAtividade}/${checklist.IdChecklist}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeChecklist', checklist.IdChecklist);
  },
  // Cliente
  async fetchAllAtividadeClientes({ commit }) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecliente`);
    if (response.data.Clientes) {
      commit('setAllAtividadeClientes', response.data.Clientes);
    } else {
      commit('setAllAtividadeClientes', []);
    }
  },
  async fetchAllAtividadeClientesNode({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/atividadesclientes/1`);
      if (response.data.length) {
        commit('setAllAtividadeClientes', response.data);
      } 
    } catch (error) {
      commit('setAllAtividadeClientes', []); 
    }
  },
  async fetchAtividadeClientes({ commit }, id) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecliente/1/${id}`);
    if (response.data.Clientes) {
      commit('setAtividadeClientes', response.data.Clientes);
    } else {
      commit('setAtividadeClientes', []);
    }
  },
  async fetchAtividadeClientesNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadesclientes/1/${id}`);
    if (response.data.length) {
      commit('setAtividadeClientes', response.data);
    } else {
      commit('setAtividadeClientes', []);
    }
  },
  async fetchAtividadeProjetosNode({ commit }, id) {
    const response = await axios.get(`${baseUrl}/atividadesvinculosprojetos/1/${id}`);
    if (response.data.length) {
      commit('setAtividadeProjetos', response.data);
    } else {
      commit('setAtividadeProjetos', []);
    }
  },
  async addClienteNode({ commit }, cliente) {
    try {
      // const response = await axios.post(`${baseUrl}/atividadesclientes`, cliente);
      const response = await atividadeService.addAtividadeCliente(cliente);
      commit('newClienteAtividade', cliente);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error;
    }
  },
  async addCliente2({ commit }, cliente) {
    await axios.post('http://nuvem.syclus.com.br:5000/api/syclus/sistema/atividadecliente', cliente, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('addClienteAtividadeSelected', cliente);
  },
  async addClienteAtividadeSelectedNode({ commit }, cliente) {
    try {
      // const response = await axios.post(`${baseUrl}/atividadesclientes`, cliente);
      const response = await atividadeService.addAtividadeCliente(cliente);
      commit('addClienteAtividadeSelected', cliente);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error;
    }
  },
  async deleteClienteNode({ commit }, cliente) {
    await axios.delete(`${baseUrl}/atividadesclientes/1/${cliente.IdAtividade}/${cliente.IdCliente}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeCliente', cliente.IdCliente);
  },
};

const mutations = {
  // Atividade
  resetAtividadeState: state => Object.assign(state, getDefaultState()),
  setAtividades: (state, atividades) => state.atividades = atividades,
  newAtividadeSelected: (state, atividades) => state.atividadesSelected = atividades,
  newAtividade: (state, atividade) => state.atividades.push(atividade),
  removeAtividade: (state, id) => state.atividades = state.atividades.filter(atividade => atividade.IdAtividade !== id),
  updateAtividade: (state, updAtividade) => {
    const index = state.atividades.findIndex(atividade => atividade.IdAtividade === updAtividade.IdAtividade);
    if (index !== -1) {
      state.atividades.splice(index, 1, updAtividade);
    }
  },
  finalizaAtividade: (state, finAtividade) => {
    const index = state.atividades.findIndex(atividade => atividade.IdAtividade === finAtividade.IdAtividade);
    if (index !== -1) {
      state.atividades.splice(index, 1, finAtividade);
    }
  },
  resetAtividadesSelected: state => state.atividadesSelected = [],
  // Ocorrências
  setOcorrencias: (state, ocorrencias) => state.ocorrencias = ocorrencias.reverse(),
  newOcorrencia: (state, ocorrencia) => state.ocorrencias.unshift(ocorrencia),
  removeOcorrencia: (state, id) => state.ocorrencias = state.ocorrencias.filter(ocorrencia => ocorrencia.IdOcorrencia !== id),
  updateOcorrencia: (state, updOcorrencia) => {
    const index = state.ocorrencias.findIndex(ocorrencia => ocorrencia.IdOcorrencia === updOcorrencia.IdOcorrencia);
    if (index !== -1) {
      state.ocorrencias.splice(index, 1, updOcorrencia);
    }
  },
  // Tags
  setAtividadeTags: (state, tags) => state.atividadeTags = tags,
  newAtividadeTag: (state, tag) => state.atividadeTags.push(tag),
  removeAtividadeTag: (state, id) => state.atividadeTags = state.atividadeTags.filter(tag => tag.IdTag !== id),
  // Colaboradores
  setAtividadeColaboradores: (state, atividadeColaboradores) => state.atividadeColaboradores = atividadeColaboradores,
  newAtividadeColaborador: (state, colaborador) => state.atividadeColaboradores.push(colaborador),
  removeAtividadeColaborador: (state, id) => state.atividadeColaboradores = state.atividadeColaboradores.filter(colaborador => colaborador.IdColaborador !== id),
  // Checklists
  setChecklists: (state, checklists) => state.checklists = checklists,
  newChecklist: (state, checklist) => state.checklists.push(checklist),
  removeChecklist: (state, id) => state.checklists = state.checklists.filter(checklist => checklist.IdChecklist !== id),
  updateChecklist: (state, updChecklist) => {
    const index = state.checklists.findIndex(checklist => checklist.IdChecklist === updChecklist.IdChecklist);
    if (index !== -1) {
      state.checklists.splice(index, 1, updChecklist);
    }
  },
  // Clientes
  setAllAtividadeClientes: (state, atividadeClientes) => state.allAtividadeClientes = atividadeClientes,
  setAtividadeClientes: (state, atividadeClientes) => state.atividadeClientes = atividadeClientes,
  newClienteAtividade: (state, cliente) => state.atividadeClientes.push(cliente),
  addClienteAtividadeSelected: (state, cliente) => state.allAtividadeClientes.push(cliente),
  removeCliente: (state, id) => state.atividadeClientes = state.atividadeClientes.filter(cliente => cliente.IdCliente !== id),
  // Projetos
  setAtividadeProjetos: (state, atividadeProjetos) => state.atividadeProjetos = atividadeProjetos,
};

export default {
  state,
  getters,
  actions,
  mutations
}